import { combineReducers } from 'redux';
import alert from './modules/alert';
import session from './modules/session';
import knock from './modules/knock';
import token from './modules/token';
import sayCode from './modules/sayCode';
import login from './modules/login';
import profile from './modules/profile';
import services from './modules/services';
import filters from './modules/filters';
import regionOfLocation from './modules/regionOfLocation';
import neighborhood from './modules/neighborhood';
import cities from './modules/cities';
import switchBusiness from './modules/switchBusiness';
import createBusiness from './modules/createBusiness';
import postChains from './modules/postChain/list';
import postChainDetail from './modules/postChain/get';
import userSite from './modules/site/userSite';
import userSiteInfo from './modules/site/userSiteInfo';
import businessDocumentList from './modules/businessDocumentList';
import ipgMine from './modules/ipgMine';
import invoiceList from './modules/invoice/list';
import invoicePrepare from './modules/invoice/prepare';
import invoiceDetail from './modules/invoice/detail';
import campaignList from './modules/campaignList';
import sliderList from './modules/sliderList';
import logout from './modules/logout';
import tilesList from './modules/tilesList';
import customers from './modules/customers';
import blogPosts from './modules/blog/list';
import blogComments from './modules/blog/comments';
import blogServices from './modules/blog/services';
import blogAuthors from './modules/blog/authors';
import appSliderList from './modules/appSliderList';
import tags from './modules/tags';


export default combineReducers({
  alert,
  appSliderList,
  blogAuthors,
  blogComments,
  blogPosts,
  blogServices,
  businessDocumentList,
  campaignList,
  cities,
  createBusiness,
  customers,
  filters,
  invoiceDetail,
  invoiceList,
  invoicePrepare,
  ipgMine,
  knock,
  login,
  logout,
  neighborhood,
  postChainDetail,
  postChains,
  profile,
  regionOfLocation,
  sayCode,
  services,
  session,
  sliderList,
  switchBusiness,
  tilesList,
  token,
  userSite,
  userSiteInfo,
  tags
});
